const sieReplacementCategories = {
    PEI: 'PEI',
    Register: 'registro',
    Referred: 'referido',
    Query: 'consulta',
  };
  
  export default sieReplacementCategories;